import * as ActionConfigurationManager from './config.actions';

export const sendDrips = ActionConfigurationManager.SEND_DRIPS
export const sendDripsPhone = ActionConfigurationManager.SEND_DRIPS_PHONE
export const sendDripsSuccess = ActionConfigurationManager.SEND_DRIPS_SUCCESS
export const sendDripsFailed = ActionConfigurationManager.SEND_DRIPS_FAILED
export const activateDrips = ActionConfigurationManager.ACTIVATE_DRIPS
export const deactivateDrips = ActionConfigurationManager.DEACTIVATE_DRIPS